import './CountryPage.css';

export const Questions = ({ country }) => {
    return (
        <div className="main-content">
            <section className="faq-section">
                <h2>Have any question in mind?</h2>
                <div className="faq-list">
                    { country.faqs.map((faq, index) => (
                        <div key={index} className="faq-item">
                            <h4>{ faq.question }</h4>
                            <p>{ faq.answer }</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}